import { render, staticRenderFns } from "./GlobalProviderSpotlight.vue?vue&type=template&id=8ce0969a&scoped=true"
import script from "./GlobalProviderSpotlight.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalProviderSpotlight.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalProviderSpotlight.vue?vue&type=style&index=0&id=8ce0969a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce0969a",
  null
  
)

export default component.exports